import React from "react";

import Container from 'react-bootstrap/Container';

import "./Philosophy.scss";

export default function Philosophy() {
    return (
        <section className="philosophy-section">
            <Container>
                <div className="philosophy-content">
                    <h2 className="philosophy-title">Our Philosophy</h2>
                    <p className="philosophy-body">
                        Welcome to Better Days Psychiatry and Family Practice! We strive to provide high quality health care that focuses on improving mental and physical health.  We use an evidence-based methodology that follows a holistic approach to health care.  We collaborate with our patients and encourage them to focus on mental,  physical, emotional, social, and spiritual well-being.
                    </p>
                    <p className="philosophy-body">
                        At Better Days Psychiatry and Family Practice, we desire to provide health services to our clients through a long term trustworthy therapeutic relationship.  We use different modalities such as preventative measures, patient education, medication management and supportive counseling.  We are compassionate about listening empathetically to our clients needs and helping achieve their goals and improve their quality of life.
                    </p>
                </div>
            </Container>
        </section>
    );
}
